export const LongWordWrapper = ({ children }: React.PropsWithChildren): JSX.Element => (
  <span className='break-all'>{children}</span>
)
